<!-- =========================================================================================
  File Name: DashboardAnalytics.vue
  Description: Dashboard Analytics
========================================================================================== -->

<template>
  <div id="dashboard-analytics">

    <div class="vx-row">
      <!-- Open Appointments  -->
      <div id="div-open-appointments" class="vx-col w-full vs-con-loading__container">
        <vx-card title="Seus atendimentos em aberto">
          <div slot="no-body" class="mt-4">
            <vs-table :data="users">
              <template slot="thead">
                <vs-th>Protocolo</vs-th>
                <vs-th>Paciente</vs-th>
                <vs-th>Encaminhado por</vs-th>
                <vs-th>Status</vs-th>
                <vs-th>Data</vs-th>
                <vs-th>Atender</vs-th>
              </template>

              <template slot-scope="{data}">
                <vs-tr :key="indextr" v-for="(tr, indextr) in data">
                  <vs-td :data="data[indextr].id">
                    <span>{{data[indextr].id}}</span>
                  </vs-td>
                  <vs-td :data="data[indextr].id">
                    <span>{{data[indextr].patient.name}}</span>
                  </vs-td>
                  <vs-td :data="data[indextr].id">
                    <span>{{data[indextr].patient.forwardedBy}}</span>
                  </vs-td>
                  <vs-td :data="data[indextr].status">
                    <span class="flex items-center px-2 py-1 rounded"><div class="h-3 w-3 rounded-full mr-2" :class="'bg-' + data[indextr].statusColor"></div>{{data[indextr].status}}</span>
                  </vs-td>
                  <vs-td :data="data[indextr].id">
                    <span>{{data[indextr].scheduleDate}}</span>
                  </vs-td>
                  <vs-td :data="data[indextr].id">
                    <router-link :to="{name: 'appointment-edit', params: { id: data[indextr].id }}">
                      <!-- <button id="myButton" class="foo bar">Go!</button> -->
                      <vs-button radius  color="primary" type="border" icon-pack="feather" icon="icon-calendar"></vs-button>
                    </router-link>
                    
                  </vs-td>
                </vs-tr>
              </template>
            </vs-table>
          </div>

        </vx-card>
      </div>
    </div>

  </div>
</template>

<script>
import StatisticsCardLine from '@/components/statistics-cards/StatisticsCardLine.vue';
import ChangeTimeDurationDropdown from '@/components/ChangeTimeDurationDropdown.vue';
import ScheduleService from '../services/ScheduleService';

export default {
    components: {
        StatisticsCardLine,
        ChangeTimeDurationDropdown,
        ScheduleService
    },
    data() {
        return {
            notifications: 
            {
              notify: this.$vs.notify,
              dialog: this.$vs.dialog,
              errors: [],
              showSucces: true,
              showError: true
            },
            isImp: false,
            navbarSearchAndPinList: this.$store.state.navbarSearchAndPinList,
            show: false,
            items: [1, 2, 3, 4, 5, 6, 7, 8, 9],
            nextNum: 10,
            'tableList': [
                'vs-th: Component',
                'vs-tr: Component',
                'vs-td: Component',
                'thread: Slot',
                'tbody: Slot',
                'header: Slot'
            ],
            users: [
            ]
        }
    },
    mounted: function () {
      this.GetPendingSchedules();
    },
    methods: {
      async GetPendingSchedules() {
          this.openLoadingInDiv('div-open-appointments');

          const payload = {
              data: {
                StatusList: [
                  "Scheduled"
                ],
              },
              notifications: this.notifications
          };

          payload.notifications.showSucces = false;

          var result = await ScheduleService.search(payload);

          if(result.status == 200) {
            this.users = result.data;
          }

          this.$vs.loading.close('#div-open-appointments > .con-vs-loading');
          // this.$vs.loading.close();
      },
      openLoadingInDiv(divId){
        this.$vs.loading({
          container: '#' + divId,
          scale: 0.6
        });
      },
      closeLoadingDiv(divId) {
        this.$vs.loading.close('#' + divId + ' > .con-vs-loading');
      }
    }
}
</script>

<style lang="scss">
#dashboard-analytics {
  @media(max-width: 576px) {
    .decore-left, .decore-right{
      width: 140px;
    }
  }
}
</style>
